import BaseServiceHttp from '../baseService'
class StatusEmprestimos extends BaseServiceHttp {
  constructor(id) {
    const resource = 'status-emprestimos'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new StatusEmprestimos(id)
